var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 116,
    height: 116,
    viewBox: "0 0 116 116"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#8f8f8f}"))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h116v116H0z",
    style: {
      fill: "none"
    },
    transform: "translate(.001 .001)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.57 14.175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.891 87.637H14.972a15.19 15.19 0 0 1-13.18-7.3 13.22 13.22 0 0 1 0-13.29l34.356-60.68a13.18 13.18 0 0 1 22.563 0l34.43 60.678a13.22 13.22 0 0 1 0 13.29 15.19 15.19 0 0 1-13.253 7.3ZM42.501 9.98 8.072 70.66a5.77 5.77 0 0 0 0 5.988 7.78 7.78 0 0 0 6.864 3.655h64.955a7.78 7.78 0 0 0 6.864-3.651 5.77 5.77 0 0 0 0-5.988L52.359 9.98a5.878 5.878 0 0 0-9.858 0",
    className: "b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.43 54.778a3.65 3.65 0 0 0 3.649-3.651V29.221a3.651 3.651 0 1 0-7.3 0v21.906a3.65 3.65 0 0 0 3.651 3.651",
    className: "b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.477,
    cy: 5.477,
    r: 5.477,
    className: "b",
    transform: "translate(41.953 62.08)"
  }))));
};
export { SvgError as Icon };
export default __webpack_public_path__ + "static/media/d7455579ed4acab8955e78b908adb6ef.svg";